function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomFireplaceFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M30 28v2H2v-2h28z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 7v23H4V7h24zM6 28h20V9H6v19z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 19a6 6 0 00-12 0v5h12v-5zm2 7H8v-7a8 8 0 1116 0v7zM30 3v6H2V3h28zM4 7h24V5H4v2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.374 14.4a1 1 0 011.731.964l-.003.01c-.005.013-.014.036-.024.067a3.89 3.89 0 00-.077.274c-.059.24-.108.537-.102.824.007.292.07.5.164.637a.725.725 0 00.345.259 1.63 1.63 0 00.201-.141c.221-.184.391-.425.391-.794a1 1 0 011.82-.573l.002.004a.1.1 0 00.003.005l.01.015.037.053c.03.044.069.107.117.184.097.156.226.375.363.64.269.518.594 1.262.732 2.06.137.793.11 1.784-.52 2.629-.634.85-1.707 1.323-3.152 1.46a4.69 4.69 0 01-.942-.002 5.242 5.242 0 01-1.538-.396c-.58-.256-1.225-.703-1.609-1.47-.39-.78-.429-1.728-.105-2.82.32-1.08 1.006-2.357 2.156-3.89zm-.009 3.83a5.62 5.62 0 00-.23.626c-.221.75-.127 1.15-.024 1.358.11.219.318.397.631.536.316.14.67.207.94.236.172.019.353.018.54 0 1.143-.108 1.573-.442 1.739-.665.17-.228.241-.577.152-1.094a3.839 3.839 0 00-.122-.489c-.034.032-.066.064-.1.093a3.699 3.699 0 01-1.057.611l-.01.004-.004.001-.002.001s-.002 0-.318-.948l.316.948a1.001 1.001 0 01-.512.032c-.847-.169-1.483-.579-1.89-1.171-.018-.026-.032-.054-.049-.08z",
    fill: props.color
  }));
}

export default SvgIconRoomFireplaceFilled;